export default __webpack_public_path__ + "static/media/Beard_8_C1.b7843a5a.svg";